export const openStats = (Id1, Id2, seasonId) => {

    // remove unifies-feed prefixes
    if(String(Id1).indexOf(srvg.config.unifiedPrefixes.competitor)!=-1) {
        Id1 = parseInt(Id1.substring(srvg.config.unifiedPrefixes.competitor.length), 10);
    }
    if(String(Id2).indexOf(srvg.config.unifiedPrefixes.competitor)!=-1) {
        Id2 = parseInt(Id2.substring(srvg.config.unifiedPrefixes.competitor.length), 10);
    }
    if(String(seasonId).indexOf(srvg.config.unifiedPrefixes.season)!=-1) {
        seasonId = parseInt(seasonId.substring(srvg.config.unifiedPrefixes.season.length), 10);
    }

    srvg.customerIntegration.openStatisticHead2head(Id1, Id2, seasonId);

    return false;
}